{
  "slug": "what-is-the-average-iq",
  "title": "Quel est le QI moyen?",
  "description": "Voyez pourquoi le QI moyen est généralement. 100, comment fonctionnent les écarts-types et les centiles, et comment interpréter les comparaisons de manière responsable.",
  "summary": "Sur la plupart des échelles de QI modernes, la moyenne est fixée à 100Environ les deux tiers de la population de référence se situent entre 18 et 24 ans. 85 and 115.",
  "sections": [
    {
      "heading": "Pourquoi la moyenne est? 100",
      "paragraphs": [
        "Les échelles de QI sont normalisées plutôt que basées sur un nombre fixe de réponses correctes, les éditeurs transforment les résultats bruts de sorte que le groupe de référence ait une moyenne de. 100Les tests sont périodiquement renormés à mesure que les populations et les expériences éducatives changent.",
        "Une partition proche de 100 signifie une performance proche du milieu du groupe de normes sélectionné, pas que quelqu'un ait répondu 100 Il pose des questions ou possède une quantité fixe d'intelligence."
      ]
    },
    {
      "heading": "Le commun 85–115 Gamme",
      "paragraphs": [
        "Avec un écart type de 15, about 68% d'une distribution normale se situe entre 85 to 115, et environ. 95% de 2006 70 to 130. Ce sont des approximations.",
        "Les centiles peuvent être plus faciles à comprendre: 100 est près de la 5010e centile, 115 près de la 84th, and 85 près de la 16T'â."
      ]
    },
    {
      "heading": "Utilisez les comparaisons avec prudence",
      "paragraphs": [
        "Un score doit être approprié à l’âge et à la version actuelle du test. La langue, l’éducation, la santé et le contexte sont des facteurs importants, et les comparaisons entre pays ou entre groupes démographiques sont particulièrement sensibles à l’échantillonnage et à la méthodologie.",
        "Pour un individu, un intervalle de confiance et un profil de sous-test sont plus utiles que de traiter le total comme parfaitement précis."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Is 100 Un bon QI?",
      "answer": "Une partition de 100 Le score de 100 est au centre du groupe de norme et représente la performance typique sur les capacités évaluées."
    },
    {
      "question": "Quel pourcentage de personnes obtient un score supérieur à? 100?",
      "answer": "Environ la moitié de la note ci-dessus 100 et la moitié en dessous, bien que les distributions de norme réelles ne soient pas parfaitement symétriques."
    }
  ],
  "related": ["iq-score-ranges-explained", "what-does-an-iq-of-120-mean", "how-is-iq-measured"]
}
